import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as orderLineSelectors, actions as orderLineActions } from 'ducks/salesOrderEnquiry/orderLine';
import { selectors as orderSelectors } from 'ducks/salesOrderEnquiry/salesOrder';
import { fetch } from 'api/salesOrderEnquiry/salesOrderLines';

const params = new URLSearchParams(location.search);

export const mapStateToProps = state => ({
  gridName: 'OrderLines',
  columnDefs: orderLineSelectors.orderLineColumns(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state), //to trigger update size based on drawer state change
  actions: orderLineSelectors.orderLineActions(state),
  gridOptions: orderLineSelectors.gridOptions(state),
  isLoading: orderLineSelectors.isLoading(state),
  reqParams: (orderSelectors.selected(state) || params.get('SalesOrder')) &&
  {
    SalesOrder: (orderSelectors.selected(state) && orderSelectors.selected(state).SalesOrder) || params.get('SalesOrder'),
  },
  keyFields: [{ valueField: 'LineNumber', routeField: 'LineNumber' }],
  apiMethod: fetch
});

export const actions = {
  deleteSelectedRecords: orderLineActions.remove,
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: orderLineActions.setSelected
}
